import { ReactComponent as RadioIconSVG } from '@/assets/icons/RadioIcon.svg';
import { SVGProps } from 'react';

const RadioIcon = (props: SVGProps<SVGSVGElement>) => <RadioIconSVG {...props} />;

export default RadioIcon;
